import React from 'react';
import '../App.css';
import { Container, Row, Col } from 'react-bootstrap';
import DonationSupport from '../componenti/DonationSupport';

function Donate() {
  return (
    <main className="page-main">
      <Container className="inner-page pb-5">
        <section className="section-block">
          <div className="section-heading donate-heading">
            <h2>Пожертвования на строительство храма</h2>
            <p>
              С благословения правящего архиерея архиепископа Тихона Майкопского и Адыгейского
              открыт сбор на строительство нового храма, часовни и келейного корпуса.
            </p>
          </div>

          <div className="surface-card donation-card donation-top-card">
            <DonationSupport large />
          </div>
        </section>

        <section className="section-block">
          <Row className="g-4">
            <Col md={6}>
              <div className="surface-card media-card h-100">
                <img src={require('../images/201.jpg')} alt="Храм на данный момент" />
                <h4>Храм на данный момент</h4>
              </div>
            </Col>
            <Col md={6}>
              <div className="surface-card media-card h-100">
                <img src={require('../images/200.jpg')} alt="Планируемое строительство" />
                <h4>Планируемое строительство</h4>
              </div>
            </Col>
          </Row>
        </section>

        <section className="section-block">
          <div className="surface-card donation-card">
            <p>
              Сейчас храм располагается в здании бывшего хозяйственного магазина.
              Наши немногочисленные прихожане жертвуют по мере своих возможностей,
              но этого недостаточно для полноценного строительства нового храма.
            </p>
            <p>
              Все жертвователи поминаются настоятелем на каждой Литургии.
              На сегодняшний день эскиз и проект будущего храма изготовлены и утверждены.
            </p>
          </div>
        </section>
      </Container>
    </main>
  );
}

export default Donate;
